import { render, staticRenderFns } from "./millton-vineyards-and-winery.vue?vue&type=template&id=f9f6e1ae&scoped=true"
import script from "./millton-vineyards-and-winery.vue?vue&type=script&lang=js"
export * from "./millton-vineyards-and-winery.vue?vue&type=script&lang=js"
import style0 from "./millton-vineyards-and-winery.vue?vue&type=style&index=0&id=f9f6e1ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f6e1ae",
  null
  
)

export default component.exports